export default __webpack_public_path__ + "static/cooperation2-12014c72ae4fd2dcf651650e6b3340c2.png";